<template>
  <modal
    ref="traceabilityMapModal"
    class="traceability-map"
    icon-type="traceabilityMapModal"
    :close-button-enabled="true"
    template="neutral"
    :title="title"
    ref-name="traceabilityMapModal"
    @close="setTraceabilityMapModalVisible(false)"
  >
    <div
      v-if="loadingCoordinatesStatus === 'STATUS_LOADING'"
      class="loading"
    >
      <spinner />
    </div>
    <template v-else-if="locationsAvailable.length > 0">
      <GmapMap
        ref="mapRef"
        :center="locationsAvailable[0].position"
        :zoom="7"
        map-type-id="roadmap"
        style="width: 100%; height: 345px"
      >
        <GmapMarker
          v-for="(location, index) in locationsAvailable"
          :key="index"
          :icon="location.icon"
          :position="location.position"
          :clickable="false"
          :draggable="false"
          :optimized="false"
        />
      </GmapMap>

      <div class="legend">
        <md-icon md-src="/static/images/icon-lab.png" />
        <p>Seu Laboratório</p>
        <md-icon md-src="/static/images/icon-transport.png" />
        <p>Amostras em trânsito</p>
        <md-icon md-src="/static/images/icon-alvaro.png" />
        <p>NTO Alvaro</p>
      </div>
    </template>
    <div
      v-else
      class="not-found"
    >
      <div class="container">
        <md-icon md-src="/static/images/icon-no-tubes-found.svg" />
        <p>
          Tivemos um problema na sua solicitação.
          <br />
          por favor, tente mais tarde.
        </p>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Spinner from '../common/Spinner'

const BOUNDS_BACKUP = {
  na: {
    j: -26.934151450576124,
    l: -7.95486694,
  },
  ga: {
    j: -55.69347395312502,
    l: -34.85096213999998,
  },
}

export default {
  name: 'ModalMap',
  components: {
    spinner: Spinner,
  },
  props: {
    batchBarcode: {
      type: String,
    },
    placeExecutionId: {
      type: String,
    },
    OSAlvaro: {
      type: String,
    },
    examName: {
      type: String,
    },
    laboratoryLocalization: {
      type: Object,
    },
  },
  data: () => {
    return {
      locations: [
        {
          name: 'laboratory',
          icon: 'https://storageapoiob2bprd.blob.core.windows.net/front-images/icon-lab.png',
          position: {
            lat: 0,
            lng: 0,
          },
        },
        {
          name: 'transport',
          icon: 'https://storageapoiob2bprd.blob.core.windows.net/front-images/icon-in-transit.png',
          position: {
            lat: 0,
            lng: 0,
          },
        },
        {
          name: 'placeExecution',
          icon: 'https://storageapoiob2bprd.blob.core.windows.net/front-images/icon-alvaro.png',
          position: {
            lat: 0,
            lng: 0,
          },
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['isTraceabilityMapModalVisible']),
    ...mapGetters(['transportLocalization']),
    ...mapGetters(['loadingCoordinatesStatus']),
    ...mapGetters(['placeExecutionLocalization']),
    title: function () {
      return 'OS ' + this.OSAlvaro + ', Exame ' + this.examName
    },
    laboratoryCoordinate: {
      get: function () {
        return this.locations[0]
      },
      set: function (value) {
        this.locations[0] = value
      },
    },
    transportCoordinate: {
      get: function () {
        return this.locations[1]
      },
      set: function (value) {
        this.locations[1] = value
      },
    },
    placeExecutionCoordinate: {
      get: function () {
        return this.locations[2]
      },
      set: function (value) {
        this.locations[2] = value
      },
    },
    locationsAvailable: function () {
      return this.locations.filter(location => location.position.lat !== 0)
    },
  },
  watch: {
    isTraceabilityMapModalVisible: function (newValue) {
      if (newValue) {
        this.$refs.traceabilityMapModal.open()
        this.getCurrentBatchCoordinates(this.batchBarcode)
        this.getPlaceExecutionCoordinates(this.placeExecutionId)
      } else {
        this.clearAllLocations()
      }
    },
    laboratoryLocalization: function () {
      this.populateLaboratoryCoordinate()
    },
    transportLocalization: function (newValue) {
      this.populateTransportCoordinate()
    },
    placeExecutionLocalization: function (newValue) {
      this.populatePlaceExecutionCoordinate()
    },
    locationsAvailable: function (newValue) {
      this.populateAllLocations()
      this.updateMapCenter()
    },
  },
  beforeDestroy() {
    this.setTraceabilityMapModalVisible(false)
  },
  methods: {
    ...mapActions(['setTraceabilityMapModalVisible']),
    ...mapActions(['getCurrentBatchCoordinates']),
    ...mapActions(['getPlaceExecutionCoordinates']),
    ...mapActions(['clearAllCoordinates']),
    centralizeMap() {
      this.$refs.mapRef.$mapPromise.then(map => {
        const bounds = map.getBounds()
        if (bounds) {
          for (let l of this.locationsAvailable) {
            bounds.extend(l.position)
          }
          map.fitBounds(bounds)
        } else {
          map.fitBounds(BOUNDS_BACKUP)
        }
      })
    },
    populateTransportCoordinate() {
      let transport = this.transportCoordinate.position
      if (this.transportLocalization.intermediaryLatitude) {
        transport.lat = parseFloat(this.transportLocalization.intermediaryLatitude)
        transport.lng = parseFloat(this.transportLocalization.intermediaryLongitude)
      }
    },
    populateLaboratoryCoordinate() {
      let laboratory = this.laboratoryCoordinate.position
      if (this.laboratoryLocalization.latitude) {
        laboratory.lat = parseFloat(this.laboratoryLocalization.latitude)
        laboratory.lng = parseFloat(this.laboratoryLocalization.longitude)
      }
    },
    populatePlaceExecutionCoordinate() {
      let placeExecution = this.placeExecutionCoordinate.position
      if (this.placeExecutionLocalization.finalLatitude) {
        placeExecution.lat = parseFloat(this.placeExecutionLocalization.finalLatitude)
        placeExecution.lng = parseFloat(this.placeExecutionLocalization.finalLongitude)
      }
    },
    updateMapCenter() {
      var self = this
      setTimeout(function () {
        self.centralizeMap()
      }, 500)
    },
    clearAllLocations() {
      this.locations.map(function (elem) {
        elem.position.lat = 0
        elem.position.lng = 0
      })
      this.clearAllCoordinates()
    },
    populateAllLocations() {
      this.populateTransportCoordinate()
      this.populateLaboratoryCoordinate()
      this.populatePlaceExecutionCoordinate()
    },
  },
}
</script>

<style lang="scss">
.traceability-map {
  margin-top: 1em;
  font-family: 'Exo 2', sans-serif !important;

  .loading {
    margin: 8em;
  }

  .legend {
    display: flex;
    align-items: flex-start;
    padding-right: 35px;
    margin: 20px 0px 0px;

    img {
      margin-right: 10px;
    }

    p {
      margin: auto;
      margin-left: 0px;
      font-family: 'Exo 2', sans-serif !important;
      font-style: normal;
      font-weight: 300;
      font-size: 12px;
      line-height: 26px;
      color: #7a7a7a;
    }
  }

  .vue-map-container .vue-map {
    position: absolute !important;
  }

  .standard-modal__title {
    font-family: 'Exo 2', sans-serif !important;
    font-style: normal;
    font-weight: 300;
    font-size: 20px;
    line-height: 26px;
    color: #7f1a54;

    .md-icon {
      margin: 0 !important;
    }
  }

  .not-found {
    height: 345px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;

    .container {
      width: 100%;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0;

      .md-icon {
        width: 50px;
        height: 50px;
        margin-bottom: 20px;
        display: block;
      }

      p {
        font-family: 'Exo 2', sans-serif !important;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        text-align: center;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: #7a7a7a;
        margin: 0;
      }
    }
  }
}

.traceability-map .md-dialog {
  min-width: 680px;
  max-width: 70%;
  min-height: 450px;

  .md-dialog-content {
    padding: 0 34px 20px;
  }
}
</style>
